import styled from 'styled-components';

const Terms = styled.div`
margin: 0 auto;
width: 100vw;
.row {
  // width: 40vw;
  }
  font-family: 'Poppins', sans-serif;
  margin-top: 70px;
  width: 50%;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 100%;
  }

  h1 {
    margin-bottom: 40px;
  }
  ul {
    li {
      margin-bottom: 20px;
      h1 {
        margin-bottom: 10px;
        font-size: 1.5rem;
      }
      p {
        line-height: 2;
      }
    }
  }
  span {
    line-height: 2;
    font-style: italic;
  }
`;
export { Terms };
